const HomeDictionary = {
  bannerImages: () => "/slidingimages",
  serviceNames: () => "/services",
  providerStatus: () => "status",
  quickQuote: () => "quickquote/post_quick_quote",
  contactUs: () => "contact/post_contact_us",
};

export default HomeDictionary;
